// صفحة مهام تيهان - التصميم والمنطق موحّدين بـ components/EmployeeTasksPage.jsx
// employeeName/backPath: نفس الصفحة تُستخدم لـ"مهامي" بحسابات البوكسات
// (MyTasks.jsx) باسم الموظفة الظاهر - بدون props = صفحة كارينا كما هي
import React from "react";
import EmployeeTasksPage from "./components/EmployeeTasksPage";

const KarinaTasks = ({ employeeName = "تيهان", backPath = "/karina" } = {}) => (
  <EmployeeTasksPage employeeName={employeeName} title={employeeName} backPath={backPath} />
);

export default KarinaTasks;
